import React from 'react';
import {useSiteContent} from '../context/SiteContentContext';
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import SingleTestimonialContent from '../components/single-testimonial/SingleTestimonialContent';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const TestimonialsPage = () => {
    const {content}=useSiteContent();
    return (
        <>
            <Breadcrumb
                heading={content.testimonialPage?.title || ""}
                currentPage={content.testimonialPage?.title || ""} 
            />
            <SingleTestimonialContent />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default TestimonialsPage;